/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import { Stack } from "..";
import { ReactNode } from "react";

export const FieldSet = ({
  children,
  isFullWidth = false,
}: {
  children: ReactNode;
  isFullWidth: boolean;
}) => (
  <Stack
    className={cn("space-y-2.5 relative", {
      "max-w-[365px]": !isFullWidth,
    })}
  >
    {children}
  </Stack>
);

export const FieldRow = ({ children }: { children: ReactNode }) => (
  // <div className="flex flex-col sm:flex-row space-y-8 sm:space-y-s0 sm:space-x-2.5 md:space-x-8">
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-8 sm:gap-y-s0 sm:gap-x-2.5 md:gap-x-8">
    {children}
  </div>
);

export const SpanError = ({ error }: { error: Array<any> | string }) => {
  const Span = ({ children }: { children: ReactNode }) => (
    <div className="absolute -bottom-1 start-0 w-full">
      <span
        className="text-sm -text--theme-colors-danger-default absolute"
        data-error
      >
        {children}
      </span>
    </div>
  );
  if (error.length === 0) return null;
  if (Array.isArray(error)) {
    return <Span>{error[0]}</Span>;
  }
  return <Span>{error}</Span>;
};
